export default "__VITE_ASSET__95755007__"